<h3
  class="loading-pipelines text-center"
  *ngIf="!activePipeline || !activePipeline.id"
>
  <i class="fas fa-spinner fa-spin"></i> Loading pipelines...
</h3>

<h3
  class="loading-pipelines text-center text-warning"
  *ngIf="!loadingPipelines && pipelines.length == 0"
>
  No pipelines set.
</h3>

<div class="kt-widget filter" *ngIf="activePipeline && activePipeline.id">
  <div class="pipeline-filter mb-3">
    <div class="form-group m200 mr-5">
      <label for="">Pipeline</label>
      <select
        class="form-control"
        [(ngModel)]="filter.pipelineId"
        (change)="setPipeline()"
      >
        <option *ngFor="let p of pipelines" [value]="p.id">
          {{ p.label }}
        </option>
      </select>
    </div>

    <div class="form-group">
      <label for="">Add SKU to Pipeline</label>
      <div class="input-group mb-3">
        <ng-select
          [items]="rfq$ | async"
          bindLabel="internal_sku"
          [addTag]="false"
          [multiple]="false"
          [hideSelected]="true"
          [trackByFn]="trackByFn"
          [loading]="rfqLoading"
          [typeahead]="rfqInput$"
          [(ngModel)]="rfqProduct"
          name="rfqProduct"
        >
          <ng-template ng-label-tmp let-item="item">
            [{{ item.internal_sku }}] {{ item.product_name }}
          </ng-template>

          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            [{{ item.internal_sku }}] {{ item.product_name }}
          </ng-template>
        </ng-select>
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary btn-sm"
            (click)="addToPipeline()"
            type="button"
          >
            <i class="fas fa-plus"></i> Add</button
          >
        </div>
      </div>
    </div>
  </div>

  <div class="form-group">
    <label for="">Created Date</label>
    <input
      type="date"
      class="form-control"
      [(ngModel)]="filter.date"
      (keyup.enter)="getRecords()"
      (change)="getRecords()"
    />
  </div>

  <div class="form-group">
    <label for="">Product SKU</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="filter.sku"
      (keyup.enter)="getRecords()"
    />
  </div>

  <div class="form-group">
    <label for="">Product Name</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="filter.product"
      (keyup.enter)="getRecords()"
    />
  </div>

  <div class="form-group">
    <label for="">Product Dept</label>
    <select
      class="form-control"
      [(ngModel)]="filter.rfq_dept"
      (change)="getRecords()"
    >
      <option value="0">All</option>
      <option *ngFor="let pt of settingsSvc.productDepartments" [value]="pt.id">
        {{ pt.text }}</option
      >
    </select>
  </div>

  <div class="form-group">
    <label for="">Starred</label>
    <select
      class="form-control"
      [(ngModel)]="filter.starred"
      (change)="getRecords()"
    >
      <option value="-1">All</option>
      <option value="1">Starred</option>
      <option value="0">Not Starred</option>
    </select>
  </div>

  <button class="btn btn-outline-info btn-sm mr-1" (click)="resetFields()">
    <i class="fas fa-eraser"></i> Reset Filters
  </button>
</div>

<div class="rfq-list-container" *ngIf="activePipeline && activePipeline.id">
  <div class="columns" cdkDropListGroup>
    <div
      class="column"
      *ngFor="
        let stage of activePipeline.stages | orderBy: ['order'];
        let i = index
      "
    >
      <h5 class="title">
        {{ stage.stage }}
        <span class="count pull-right">
          {{ stage.count }}
        </span>
      </h5>

      <div>
        <div class="loading-rfqs text-center" *ngIf="stage.loading">
          <i class="fas fa-spinner fa-spin"></i> Getting SKUs
        </div>

        <div
          *ngIf="!stage.loading"
          [perfectScrollbar]="{ wheelPropagation: true }"
          cdkDropList
          [id]="i"
          class="column-list"
          [cdkDropListData]="stage.records"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="column-item"
            cdkDrag
            [cdkDragDisabled]="authService.loginUser.prwx == 1"
            [cdkDragData]="rfq"
            *ngFor="let rfq of stage.records"
            [ngClass]="{
              high: rfq.priority == 30,
              medium: rfq.priority == 20,
              low: rfq.priority == 10,
            }"
          >
            <div class="product">
              <a
                href="javascript:;"
                class="star mr-1"
                (click)="rfqSvc.toggleStarred(rfq)"
                ngbPopover="{{ rfq.starred ? rfq.starred_notes : '' }}"
                triggers="mouseenter:mouseleave"
                title="{{ rfq.starred ? '' : 'Mark this SKU as starred' }}"
              >
                <i class="fas fa-star text-success" *ngIf="rfq.starred == 1"></i>
                <i class="far fa-star text-secondary" *ngIf="rfq.starred == 0"></i>
              </a>
              <a
                href="javascript:;"
                title="View Details"
                class="link mr-1"
                (click)="showDetails(rfq)"
              >
                <span
                  class="sku"
                  *ngIf="rfq.internal_sku && rfq.internal_sku.length > 3"
                >
                  [{{ rfq.internal_sku }}]
                </span>
                <b>{{ rfq.product_name }}</b>
              </a>
            </div>

            <div class="status">
              <span
                *ngIf="rfq.posted_quotes_count > 0"
                class="
                  kt-badge kt-badge--success kt-badge-sm kt-badge--outline kt-badge--pill
                "
              >
                {{ rfq.posted_quotes_count }} Quotations</span
              >
              <span
                *ngIf="rfq.sample_orders_count > 0"
                class="kt-badge kt-badge--info kt-badge-sm kt-badge--pill"
              >
                {{ rfq.sample_orders_count }} Sample orders</span
              >
            </div>

            <div class="action">
              <button mat-button [matMenuTriggerFor]="menu">
                <i class="flaticon-more-1"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="moveToOtherPipeline(rfq, i)">
                  <i class="fas fa-stream"></i> Move to Pipelines
                </button>
                <!-- <button mat-menu-item (click)="setTags(rfq, i);">
                                    <i class="fas fa-tags"></i> Set Tags
                                </button> -->
              </mat-menu>

              <!-- <a href="javascript:;" class="star mr-1" (click)="moveToOtherPipeline(rfq, i);"
                                title="Move to other pipeline">
                                <i class="fas fa-exchange-alt"></i>
                            </a> -->
            </div>

            <div class="icon-row tags" *ngIf="stage.tags && stage.tags.length > 0">
              <a
                href="javascript:;"
                *ngFor="let tag of stage.tags"
                (click)="toggleTag(tag.id, rfq.activePipeline)"
                [title]="tag.tag"
              >
                <span
                  [ngStyle]="{
                    color: isTagActive(tag.id, rfq.activePipeline.tag_ids)
                      ? tag.color
                        ? tag.color
                        : 'green'
                      : '',
                  }"
                >
                  <mat-icon *ngIf="tag.icon">{{ tag.icon }}</mat-icon>
                  <b *ngIf="!tag.icon">{{ tag.tag[0].toUppercase() }}</b>
                </span>
              </a>
            </div>

            <div
              class="icon-row admins"
              *ngIf="rfq.admins && rfq.admins.length > 0"
            >
              <span
                *ngFor="let user of rfq.admins"
                title="{{ user.users.firstname + ' ' + user.users.lastname }}"
              >
                {{ user.users.firstname.charAt(0)
                }}{{ user.users.lastname.charAt(0) }}
              </span>
            </div>

            <div
              class="icon-row staff"
              *ngIf="rfq.members && rfq.members.length > 0"
            >
              <span
                *ngFor="let user of rfq.members"
                title="{{ user.users.firstname + ' ' + user.users.lastname }}"
              >
                {{ user.users.firstname.charAt(0)
                }}{{ user.users.lastname.charAt(0) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
